import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Panel URLs (embed directly; no backend calls)
const PANEL_URLS = {
    support: process.env.REACT_APP_SUPPORT_URL,
    agora: process.env.REACT_APP_AGORA_URL,
    atlas: process.env.REACT_APP_ATLAS_URL
};

// Internal routes for "open full app" link
const PANEL_PAGE_URLS = {
    support: '/support',
    agora: '/agora',
    atlas: '/atlas'
};

const RightAside = ({ children, showChildrenWhenNoPanel = true }) => {
    const [activePanel, setActivePanel] = useState(null);
    const [panelUrl, setPanelUrl] = useState(null);
    const hasChildren = !!children;
    const shouldShowChildrenByDefault = hasChildren && showChildrenWhenNoPanel;

    // Update iframe URL when active panel changes (no backend calls)
    useEffect(() => {
        if (!activePanel) {
            setPanelUrl(null);
            return;
        }
        setPanelUrl(PANEL_URLS[activePanel] || null);
    }, [activePanel]);

    useEffect(() => {
        // Initialize state from localStorage
        try {
            const savedPanel = localStorage.getItem('rightnavActivePanel');
            
            if (savedPanel && savedPanel !== 'null') {
                setActivePanel(savedPanel);
                document.body.classList.remove('rightnav-collapsed');
            } else if (shouldShowChildrenByDefault) {
                setActivePanel(null);
                document.body.classList.remove('rightnav-collapsed');
            } else {
                setActivePanel(null);
                document.body.classList.add('rightnav-collapsed');
            }
        } catch (e) {
            if (!shouldShowChildrenByDefault) {
                document.body.classList.add('rightnav-collapsed');
            }
        }

        // Listen for toggle events from Header
        const handleToggle = (event) => {
            try {
                const panel = event.detail?.panel || localStorage.getItem('rightnavActivePanel');
                if (panel && panel !== 'null') {
                    setActivePanel(panel);
                } else {
                    setActivePanel(null);
                    if (!shouldShowChildrenByDefault) {
                        document.body.classList.add('rightnav-collapsed');
                    } else {
                        document.body.classList.remove('rightnav-collapsed');
                    }
                }
            } catch (e) {}
        };
        window.addEventListener('rightnav-toggle', handleToggle);
        return () => window.removeEventListener('rightnav-toggle', handleToggle);
    }, [shouldShowChildrenByDefault]);

    return (
        <aside className="shadow-md right-aside" style={{ backgroundColor: 'var(--color2)', overflow: 'hidden', padding: 0, position: 'relative' }}>
            <div className="right-aside-inner" style={{ height: '100%', width: '100%' }}>
                {activePanel && (panelUrl ? (
                    <iframe
                        title={activePanel}
                        src={panelUrl}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    />
                ) : (showChildrenWhenNoPanel ? children : null))}
                {!activePanel && showChildrenWhenNoPanel && children}
            </div>

            {activePanel && PANEL_PAGE_URLS[activePanel] && (
                <Link
                    to={PANEL_PAGE_URLS[activePanel]}
                    style={{
                        position: "absolute",
                        left: "10px",
                        bottom: "10px",
                        zIndex: 10,
                        padding: "6px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textDecoration: "none"
                    }}
                    title={`Open ${activePanel} in full page`}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <img
                        src={require("./../assets/images/icons/arrow-up-right-from-square.png")}
                        width="20"
                        height="20"
                        alt="Open full page"
                    />
                </Link>
            )}
        </aside>
    )
}

export default RightAside;
